import { Component, input } from '@angular/core';

@Component({
  selector: 'lx-message',
  standalone: true,
  imports: [],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
  type = input<'alert' | undefined>();
  color = input<'blue' | undefined>();
}
